import type { IconName } from '@/ui/icon/icons';

export interface StaticProductOption {
    label: string;
    value: string;
    icon: IconName;
}

export const staticProductOptions: StaticProductOption[] = [
    {
        label: 'Clothing',
        value: 'clothing',
        icon: 'arrowTrendUp'
    },
    {
        label: 'Retail Store Services',
        value: 'retail store services',
        icon: 'arrowTrendUp'
    },
    {
        label: 'Retail of Clothing',
        value: 'retail of clothing',
        icon: 'arrowTrendUp'
    },
    {
        label: 'Providing Food and Drink',
        value: 'providing food and drink',
        icon: 'arrowTrendUp'
    },
    {
        label: 'Education Services',
        value: 'education services',
        icon: 'arrowTrendUp'
    },
    {
        label: 'Providing Training',
        value: 'providing training',
        icon: 'arrowTrendUp'
    }
]; 